import { Injector } from '@angular/core';
import { MatchDataService } from '../match-data.service';
import { MatchSyncService } from '../match-sync.service';
import { Match } from '../models/match.model';
import { SessionService } from '../session.service';

interface Lb3TestApi {
  applyMatches(matches: readonly Match[]): void;
  resetSports(sportIds: readonly number[]): void;
  resetWithMatches(matches: readonly Match[]): void;
  resetWithReducedMatches(matches: readonly Match[]): void;
}

declare global {
  interface Window {
    __lb3TestApi?: Lb3TestApi;
  }
}

export function installLb3TestApi(injector: Injector): void {
  const matchDataService = injector.get(MatchDataService);
  const matchSyncService = injector.get(MatchSyncService);
  const sessionService = injector.get(SessionService);

  window.__lb3TestApi = {
    applyMatches(matches): void {
      matchDataService.suspendRemoteFeedForTesting();
      matchSyncService.applyMatches(matches);
      matchDataService.markMatchDetailsLoadedForTesting(matches.map(match => match.Id));
      sessionService.setMatchesLoading(false);
    },
    resetSports(sportIds): void {
      matchDataService.suspendRemoteFeedForTesting();
      sessionService.resetLiveData();
      sessionService.setMatchesLoading(false);
      for (const sportId of sportIds) {
        sessionService.addSport(sportId);
      }
    },
    resetWithMatches(matches): void {
      matchDataService.suspendRemoteFeedForTesting();
      sessionService.resetLiveData();
      matchSyncService.applyMatches(matches);
      matchDataService.markMatchDetailsLoadedForTesting(matches.map(match => match.Id));
      sessionService.setMatchesLoading(false);
    },
    resetWithReducedMatches(matches): void {
      matchDataService.suspendRemoteFeedForTesting();
      sessionService.resetLiveData();
      matchSyncService.applyMatches(matches);
      matchDataService.markMatchDetailsReducedForTesting(matches.map(match => match.Id));
      sessionService.setMatchesLoading(false);
    }
  };
}
